import {ServiceCharge} from '../../model/admin/servicecharge';
import {BaseResponse} from '../internal/baseresponse';
export class ADMServiceChargeDetailResult extends BaseResponse {
  data: ServiceCharge;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admservicechargedetailresult.ts